import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useRecordingDataSession() {
  const [data, setData] = useState({});
  const store = useSelector((state) => state.recordingmodul_user_data);

  useEffect(() => {
    if (store.success) {
      setData(store.data);
    }
  }, [store]);

  return {
    selfUid: data.uId,
    tokenAgora: data.agoraToken,
    session: data.session,
    listUser: data.listUser,
    dataSession: data,
  };
}
